import Card from 'antd/es/card/Card';
import Colors from 'enums/Colors';
import { Description } from 'pages/biblioteca_v2/components/categoria-item/DefaultItem.styled';
import { SubTitle } from 'pages/profile/components/formHeader/FormHeader.styled';
import styled from 'styled-components';

const CertificadoPublicContainer = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        align-self: center;
        justify-self: center;

        padding-top: 120px;
        color: ${Colors.Blue};
    `,

    Header: styled.div`
        display: flex;
        flex-direction: column;
        min-width: 1200px;

        @media screen and (max-width: 1250px) {
            min-width: 100%;
            padding: 8px;
        }
    `,

    Title: styled.h1`
        display: flex;
        align-items: center;
        gap: 24px;
        font-family: 'Barlow';
        font-weight: 700;
        font-style: Bold;
        font-size: 48px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
    `,

    SubTitle: styled.h1`
        font-family: 'Barlow';
        font-weight: 700;
        font-style: Bold;
        font-size: 48px;
        line-height: 150%;
        letter-spacing: -1%;
        text-align: center;
        vertical-align: middle;
        color: ${Colors.Blue};
    `,

    Description: styled.p`
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 20px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
    `,

    Content: styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        min-height: 500px;
        background-color: #f6f6f6;
        margin-top: 76px;
        padding-bottom: 100px;
        padding-top: 40px;
        gap: 28px;

        @media screen and (max-width: 1250px) {
            padding: 8px;
            gap: 20px;
            padding-bottom: 100px;
        }
    `,

    ContentGrid: styled.div`
        display: grid;
        width: 100%;
        max-width: 1200px;
        grid-template-columns: 1fr 1fr;
        grid-gap: 24px;
        padding-bottom: 10px;
    `,

    Card: styled.div`
        width: 100%;
        gap: 45px;
        min-height: 312px;
        opacity: 1;
        border-radius: 24px;
        border-width: 1px;
        padding-top: 38px;
        padding-right: 47px;
        padding-bottom: 38px;
        padding-left: 47px;
        background-color: ${Colors.White};
        color: ${Colors.Blue};

        font-family: 'Barlow';

        font-size: 20px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
    `,

    Row: styled.div`
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 40px;
        width: 100%;
    `,

    BackButton: styled.button`
        display: flex;
        align-items: center;
        background-color: transparent;
        border: none;
        gap: 1rem;

        font-family: 'Barlow';
        font-weight: 600;
        font-style: SemiBold;
        font-size: 20px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;

        color: ${Colors.Blue};
    `,
};

export default CertificadoPublicContainer;
